import React from "react"
import Popup from "../../component/popup/popup"
import Grid from "@mui/material/Grid"
import { AgencyData, OfficeData } from "../../models"
import styles from "../../asset/styles/agents/agencyViewPopup.module.scss"
import utilStyles from "../../asset/styles/util/util.module.scss"
import { formatPhoneForDisplay } from "util/phoneDisplayUtil"

type AgencyViewPopupProps = {
    isOpen: boolean
    onClose: () => void
    agency: AgencyData | null
    onEdit: () => void
}

const AgencyViewPopup: React.FC<AgencyViewPopupProps> = ({ isOpen, onClose, agency, onEdit }) => {
    if (!agency) return null

    return (
        <Popup
            isOpen={isOpen}
            onClose={onClose}
            title="Agency Details"
            primaryButton={{ label: "Edit", onClick: onEdit }}
            secondaryButton={{ label: "Close", onClick: onClose }}
            size="large"
        >
            <div className={styles.viewContainer}>
                {/* Agency Information Section */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Agency Information</h3>
                        <span className={agency.flag_active ? utilStyles.statusBadgeActive : utilStyles.statusBadgeInactive}>
                            {agency.flag_active ? "Active" : "Inactive"}
                        </span>
                    </div>
                    <div className={styles.sectionDivider} />

                    <Grid container spacing={3} style={{ marginTop: 4 }}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <div className={styles.fieldGroup}>
                                <span className={styles.fieldLabel}>Agency Name</span>
                                <span className={styles.fieldValue}>{agency.agency_name || "-"}</span>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <div className={styles.fieldGroup}>
                                <span className={styles.fieldLabel}>Contact Person Name</span>
                                <span className={styles.fieldValue}>{agency.contact_person_name || "-"}</span>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <div className={styles.fieldGroup}>
                                <span className={styles.fieldLabel}>Phone Number</span>
                                <span className={styles.fieldValue}>{formatPhoneForDisplay(agency.phone_number) || "-"}</span>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <div className={styles.fieldGroup}>
                                <span className={styles.fieldLabel}>Email ID</span>
                                <span className={styles.fieldValue}>{agency.email || "-"}</span>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                {/* Offices Section */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>
                            Offices ({agency.office?.length ?? 0})
                        </h3>
                    </div>
                    <div className={styles.sectionDivider} />

                    {agency.office && agency.office.length > 0 ? (
                        <div className={styles.officeList}>
                            {agency.office.map((office: OfficeData, index: number) => (
                                <div key={office.office_id || index} className={styles.officeCard}>
                                    <div className={styles.officeCardHeader}>
                                        <span className={styles.officeIndex}>Office {index + 1}</span>
                                        <span className={office.flag_active ? utilStyles.statusBadgeActive : utilStyles.statusBadgeInactive}>
                                            {office.flag_active ? "Active" : "Inactive"}
                                        </span>
                                    </div>
                                    <Grid container spacing={2} style={{ marginTop: 4 }}>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <div className={styles.fieldGroup}>
                                                <span className={styles.fieldLabel}>Office Name</span>
                                                <span className={styles.fieldValue}>{office.office_name || "-"}</span>
                                            </div>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <div className={styles.fieldGroup}>
                                                <span className={styles.fieldLabel}>City</span>
                                                <span className={styles.fieldValue}>{office.city_name || "-"}</span>
                                            </div>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <div className={styles.fieldGroup}>
                                                <span className={styles.fieldLabel}>Address</span>
                                                <span className={styles.fieldValue}>{office.address || "-"}</span>
                                            </div>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <div className={styles.fieldGroup}>
                                                <span className={styles.fieldLabel}>Contact Number</span>
                                                <span className={styles.fieldValue}>{formatPhoneForDisplay(office.contact_number) || "-"}</span>
                                            </div>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <div className={styles.fieldGroup}>
                                                <span className={styles.fieldLabel}>Email ID</span>
                                                <span className={styles.fieldValue}>{office.email || "-"}</span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className={styles.noData}>No offices found</p>
                    )}
                </div>
            </div>
        </Popup>
    )
}

export default AgencyViewPopup
